export default "__VITE_ASSET__MojqQd$4__"